import { MINUTES_IN_HOUR } from '@repo/date-time';
const DAY_SCALE_PIXELS_PER_HOUR = 72;
export const DEFAULT_MINUTE_STEP = 5;
export const TIME_SLIDER_RATIO = DAY_SCALE_PIXELS_PER_HOUR / MINUTES_IN_HOUR;
